
export const LEAP = {
    AUTH: {
        IDENTIFIERS: {
            QUERY_PARAMETER: 'access_token',
            HEADER: 'Authorization',
            TOKEN_TYPE: 'Bearer'
        },
        GRANT_TYPE: {
            REFRESH_TOKEN: 'refresh_token',
            AUTHORIZATION_CODE: 'authorization_code'
        }
    }
};

export const HTTP = {
    HEADERS: {
        NAME: {
            CONTENT_TYPE: 'Content-Type'
        },

        CONTENT_TYPE: {
            FORM_URL_ENCODED_UTF8: 'application/x-www-form-urlencoded; charset=UTF-8',
            JSON: 'application/json',
        }
    }
};